import {DisableMobileApplicationRequestStatusEnum} from '@/services/api-clients';

export function disableMobileApplicationRequestStatusIconFilter(status: DisableMobileApplicationRequestStatusEnum): string {
  switch (status) {
    case DisableMobileApplicationRequestStatusEnum.Pending: return 'mdi-clock-outline';
    case DisableMobileApplicationRequestStatusEnum.Finished: return 'mdi-account-off';
  }
}
